export const BUILDERCOMMENTS = [

    { 
        id: 0,
        type: "Intro",
        text: "is an enthusiastic learner who seems to enjoy school. ",
        
    },
    { 
        id: 1,
        type: "Intro",
        text: "arrives on time to school every day and is always well prepared for class. ",
        
    },
    { 
        id: 2,
        type: "Intro",
        text: "sets an example of excellence in behavior and cooperation. ",
        
    },
    { 
        id: 3,
        type: "Intro",
        text: "comes to class on time every day with a smile on student face. ",

    },
    { 
        id: 4,
        type: "Intro",
        text: "is an energetic outgoing student who makes friends easily. ",
        
    },
    { 
        id: 5,
        type: "Character",
        text: "Student shows respect for teachers and peers. ",
            
    },
    { 
        id: 6,
        type: "Character",
        text: "Student has incredible self-discipline and is always focused on the task at hand. ",
            
    },
    { 
        id: 7,
        type: "Character",
        text: "Student is a model citizen in our classroom. "
            
    },
    { 
        id: 8,
        type: "Character",
        text: "Student is exceptionally organized and takes care of student things. ",
            
    },
    { 
        id: 9,
        type: "Character",
        text: "Student is agreeable and polite when working with others. ",
            
    },
	{ 
        id: 10,
        type: "Time",
        text: "Student always uses class time wisely. ",
        
    },
	{ 
        id: 11,
        type: "Time",
        text: "Student consistently completes assignments in the time allotted and turns in homework on time. ",
            
    },
	{ 
        id: 12,
        type: "Time",
        text: "Student works at the appropriate pace, neither too quickly or slowly. ",
            
    },
	{ 
        id: 13,
        type: "Time",
        text: "Student has a difficult time staying on task and completing student work.",
    
    },
	{ 
        id: 14,
        type: "Time",
        text: "Student has to be frequently reminded to get started on assignments. ",
        
    },
	{ 
        id: 15,
        type: "Work",
        text: "Student is very hardworking and always completes all of student work enthusiastically. ",
            
    },
	{ 
        id: 16,
        type: "Work",
        text: "Student works independently and doesn\'t get distracted easily. ",
            
    },
	{ 
        id: 17,
        type: "Work",
        text: "Student generates neat and careful work. ",
            
    },
	{ 
        id: 18,
        type: "Work",
        text: "Student checks work thoroughly before submitting it. ",
            
    },

    { 
        id: 19,
        type: "Work",
        text: "Student gives up easily when something is difficult and needs extensive encouragement to attempt the task. ",
            
    },
	{ 
        id: 20,
        type: "Work",
        text: "Student rushes to complete tasks resulting in assignments with careless errors. ",
            
    },
	{ 
        id: 21,
        type: "Reading",
        text: "Student is reading above grade level.  ",
            
    },
	{ 
        id: 22,
        type: "Reading",
        text: "Student has good reading comprehension and decoding skills. ",
            
    },
	{ 
        id: 22,
        type: "Reading",
        text: "Student struggles with reading comprehension. ",
        
    },
	{ 
        id: 23,
        type: "Reading",
        text: "Student has difficulty using foundational reading strategies to decode new words. ",
            
    },
	
    { 
        id: 24,
        type: "Reading",
        text: "Student is encouraged to read for 15 minutes each night at home to improve student fluency. ",
            
    },
    { 
        id: 25,
        type: "Writing",
        text: "Student writing has a refreshing sense of voice, clarity, and style. ",
    },
    { 
        id: 26,
        type: "Writing",
        text: "Student writing is clear, organized, and interesting to read. ",
    },
    { 
        id: 27,
        type: "Writing",
        text: "Student is encouraged to check student own writing more carefully for spelling, grammar, and punctuation errors before turning in assignments. ",
    },
    { 
        id: 28,
        type: "Writing",
        text: "Student often forgets capital letters and punctuation. ",
    },
    { 
        id: 29,
        type: "Writing",
        text: "Student has difficulty organizing student thoughts in writing. ",
    },

    { 
        id: 30,
        type: "Math",
        text: "Student has a solid understanding of all math concepts taught this quarter. ",
    },
	{ 
        id: 31,
        type: "Math",
        text: "Student is an excellent mathematician. ",
    },
	{ 
        id: 32,
        type: "Math",
        text: "Student is encouraged to practice basic addition and subtraction facts to improve student speed and accuracy. ",
    },
    { 
        id: 33,
        type: "Math",
        text: "Student is able to follow mathematical strategies, but has difficulty explaining how student answers are derived. ",
    },
    { 
        id: 34,
        type: "Math",
        text: "Student is having difficulty with multiple-step math problems. ",
    },
    { 
        id: 35,
        type: "Closure",
        text: "is confident and independent and is doing well academically. ",
    },
    { 
        id: 36,
        type: "Closure",
        text: "is encouraged to be more diligent with student schoolwork. I look forward to seeing the improvements student will make next quarter. ",
    },
    { 
        id: 37,
        type: "Closure",
        text: "is an intelligent student with great potential. Student needs to work on staying focused in class and following directions. ",
    },
    { 
        id: 38,
        type: "Closure",
        text: "is encouraged to be more consistent with student effort to do well academically. ",
    },
    { 
        id: 39,
        type: "Closure",
        text: "is hardworking and is encouraged to improve student organizational and time management skills. ",
    },


]
